import Modal from "./modal";

import _ from "underscore";

export default class BulkModal extends Modal {
  title() {
    return `Apply marketing data to ${this._totalModels()} ${this.model.get("friendlyModalClassName").toLowerCase()}s`;
  }

  initialize({ dataTable }) {
    if (_.isEmpty(dataTable)) {
      throw new Error("Tried initializing Bulk Modal without a dataTable reference");
    }

    this.dataTable = dataTable;
    super.initialize.apply(this, arguments);
  }

  onSaveButtonClick(parentView) {
    this.model.set("merge", true);
    super.onSaveButtonClick(parentView);
  }

  onSuccessCallBack(responses) {
    if (responses) {
      const rawErrrors = _.map(responses, ({ errors }, x) => _.escape(errors));
      const formattedErrors = _.compact(rawErrrors).join(". ");

      if (!_.isEmpty(formattedErrors)) {
        this._showErrorText(formattedErrors);
      } else {
        this.close();
        this.dataTable.reload();
      }
    }
  }

  headerText() {
    if (this._totalModels() > 0) {
      return "When Marketing Data has already been applied to one or more selections in this list, newly added marketing data fields will be added, and changes to existing marketing data fields will be overridden to match the latest input.";
    }
  }

  _totalModels() {
    if (this.model.get("payloadParams") && this.model.get("payloadParams").data_owner_ids) {
      return this.model.get("payloadParams").data_owner_ids.length;
    } else {
      return 0;
    }
  }
}

_.extend(BulkModal.prototype, {
  buttons: [
    {
      text: "Cancel",
      className: "btn-secondary",
      close: true
    },
    {
      click() {
        this.parent.onSaveButtonClick.apply(this.parent);
        return true;
      },
      text: "Save",
      className: 'btn-primary save-custom-data',
      present() {
        return this._totalModels() > 0;
      }
    }
  ]
});
